import "@fontsource/roboto/latin.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LocaleContextProvider } from "./contexts/locale/locale";
import "./index.css";
import { Disclaimer } from "./pages/disclaimer/disclaimer";
import { Home } from "./pages/home/home";
import { Imprint } from "./pages/imprint/imprint";
import { Privacy } from "./pages/privacy/privacy";
import { Terms } from "./pages/terms/terms";

const rootElement = document.getElementById("root") as HTMLElement;

const root = ReactDOM.createRoot(rootElement);

const application = (
	<React.StrictMode>
		<LocaleContextProvider>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="haftung" element={<Disclaimer />} />
					<Route path="agb" element={<Terms />} />
					<Route path="datenschutz" element={<Privacy />} />
					<Route path="impressum" element={<Imprint />} />
				</Routes>
			</BrowserRouter>
		</LocaleContextProvider>
	</React.StrictMode>
);

if (rootElement && rootElement.hasChildNodes()) {
	ReactDOM.hydrateRoot(rootElement, application);
} else {
	root.render(application);
}
